import axios from "axios";
import { useEffect, useState, useContext } from "react"
import { AuthContext } from "../contexts/AuthContext";
import {ReactComponent as Triangle} from '../assets/images/icons/triangle.svg';
import { CircleCheck, DonutChart, PieChart } from "../components/utility/Utility";

export default function Onboarding() {
  const {handleSignOut, getJwtToken} = useContext(AuthContext);
  const [progress, setProgress] = useState({
    program: {
      earnings: false,
      rewards: false,
      vip: false
    },
    promotions: false,
    giveaways: false,
    shopify: false,
    customers: false,
    dashboard: false
  });
  const [selected, setSelected] = useState(0);
  const [option, setOption] = useState(false);

  useEffect(() => {
    const getOnboardingData = async () => {
      try {
        const token = await getJwtToken();
        const res = await axios.get('https://api.amplifyloyalty.com/app/stores/onboarding', {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.name === 'BadRequestError') {
          handleSignOut();
        } else {
          const earnings = Object.keys(res.data.program.earnings).reduce((acc, cV) => 
            res.data.program.earnings[cV].status === 'active' ? acc + 1 : acc, 
            0
          );
          const rewards = res.data.program.rewards.reduce((acc, cV) => 
            cV.status === "active" ? acc + 1 : acc,
            0
          );
          
          const newProgress = {
            promotions: res.data.promotions,
            giveaways: res.data.giveaways,
            shopify: res.data.shopify,
            program: {
              earnings,
              rewards,
              vip: res.data.vip
            },
            customers: res.data.customers,
            dashboard: res.data.dashboard
          };
          setProgress(newProgress);
          findFirstUnfinished(0, newProgress);
        }
      } catch (err) {
        console.log(err);
      }
    }
    getOnboardingData();
  }, [])

  const findFirstUnfinished = (sel, pro) => {
    switch (sel) {
      case 0:
        setOption(
          pro.shopify === 'active' ?
            pro.program.earnings > 0 && pro.program.rewards > 0 ?
              pro.customers ? 
                0 :
                2
            : 1
          : 0
        )
        break;
      default:
        setOption(0);
    }
  }
  useEffect(() => {
    findFirstUnfinished(selected, progress);
  }, [selected]);

  return (
    <div className="main">
      <div className="onboarding">
        <div className="onboarding__sidebar">
          <div 
            className={`onboarding__button${selected === 0 ? ' onboarding__button--selected' : ''}`}
            onClick={() => setSelected(0)}
          >
            {
              (
                progress.shopify !== 'active' || 
                (progress.program.earnings === 0 || progress.program.rewards === 0) ||
                !progress.customers 
              ) ?
                <DonutChart percentage={["shopify", "program", "customers"].reduce((acc, cV) => {
                  switch (cV) {
                    case "shopify":
                      return progress.shopify !== 'active' ? acc : acc + (1/3);
                    case "program":
                      return progress.program.earnings > 0 && progress.program.rewards > 0 ? acc + (1/3) : acc;
                    case "customers":
                      return progress.customers ? acc + (1/3) : acc;
                    default: 
                      return acc;
                  }
                }, 0)} size={18} /> :
                <CircleCheck style={{display: "flex", alignItems: "center"}}/>

            }
            <div className="onboarding__button-text">Essentials</div>
          </div>
          <div 
            className={`onboarding__button${selected === 1 ? ' onboarding__button--selected' : ''}`}
            onClick={() => setSelected(1)}
          >
            {!progress.program.vip ? 
              <DonutChart percentage={0} size={18} /> :
              <CircleCheck style={{display: "flex", alignItems: "center"}}/>
            }
            <div className="onboarding__button-text">VIP Program</div>
          </div>
          <div 
            className={`onboarding__button${selected === 2 ? ' onboarding__button--selected' : ''}`}
            onClick={() => setSelected(2)}
          >
            {!progress.promotions ? 
              <DonutChart percentage={0} size={18} /> :
              <CircleCheck style={{display: "flex", alignItems: "center"}}/>
            }
            <div className="onboarding__button-text">Running Promotions</div>
          </div>
          <div 
            className={`onboarding__button${selected === 4 ? ' onboarding__button--selected' : ''}`}
            onClick={() => setSelected(4)}
          >
            {!progress.giveaways ? 
              <DonutChart percentage={0} size={18} /> :
              <CircleCheck style={{display: "flex", alignItems: "center"}}/>
            }
            <div className="onboarding__button-text">Creating Giveaways</div>
          </div>
          <div 
            className={`onboarding__button${selected === 5 ? ' onboarding__button--selected' : ''}`}
            onClick={() => setSelected(5)}
          >
            {!progress.dashboard ? 
              <DonutChart percentage={0} size={18} /> :
              <CircleCheck style={{display: "flex", alignItems: "center"}}/> 
            }
            <div className="onboarding__button-text">Dashboard</div>  
          </div>
        </div>


        <div className="onboarding__instructions">
          {selected === 0 && 
            <div className="onboarding__steps">
              <div className={`onboarding__step${option === 0 ? " active" : ""}${progress.shopify === 'active' ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(0)}>
                  {progress.shopify !== 'active' ? 
                    <Triangle className={`onboarding__triangle${option === 0 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">Integrate with Shopify</div>
                </div>
                  <div className="onboarding__step-description">
                    Connect your Shopify store to your Amplify Loyalty account.
                  </div>
                  {progress.shopify !== 'active' && 
                    <a 
                      href="/app/integrations/shopify"
                      className="onboarding__step-action btn gradient"
                    >Integrate</a>
                  }
              </div>
              <div className={`onboarding__step${option === 1 ? " active" : ""}${progress.program.earnings > 0 && progress.program.rewards > 0 ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(1)}>
                  {progress.program.earnings === 0 || progress.program.rewards === 0 ? 
                    <Triangle className={`onboarding__triangle${option === 1 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">Activate ways to earn and redeem</div>
                </div>
                <div className="onboarding__step-description">
                  Set up at least one way to earn and one coupon to redeem.
                </div>
                  <a 
                    href="/app/program?tutorial=true" 
                    className="onboarding__step-action btn gradient"
                  >Start Tutorial</a>
              </div>
              <div className={`onboarding__step${option === 2 ? " active" : ""}${progress.customers ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(2)}>
                  {!progress.customers ? 
                    <Triangle className={`onboarding__triangle${option === 2 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">View customers and make adjustments</div>
                </div>
                <div className="onboarding__step-description">
                  Monitor customers who have interacted with your program and make manual point adjustments.
                </div>
                  <a 
                    href="/app/customers?tutorial=true" 
                    className="onboarding__step-action btn gradient"
                  >Start Tutorial</a>
              </div>
            </div>
          }

          {selected === 1 && 
            <div className="onboarding__steps">
              <div className={`onboarding__step${option === 0 ? " active" : ""}${progress.program.vip ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(0)}>
                  {!progress.program.vip ? 
                    <Triangle className={`onboarding__triangle${option === 0 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">Create your first VIP tier</div>
                </div>
                  <div className="onboarding__step-description">
                    Set up a VIP tier based on how much a customer has spent and increase their points earned or issue a coupon.
                  </div>
                    <a 
                      href="/app/vip?tutorial=true" 
                      className="onboarding__step-action btn gradient"
                    >Start Tutorial</a>
              </div>
            </div>
          }

          {selected === 2 && 
            <div className="onboarding__steps">
              <div className={`onboarding__step${option === 0 ? " active" : ""}${progress.promotions ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(0)}>
                  {!progress.promotions ? 
                    <Triangle className={`onboarding__triangle${option === 0 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">Create your first Promotion</div>
                </div>
                  <div className="onboarding__step-description">
                    Learn how to create scheduled Promotions and customize Shopify sections temporarily using Amplifiers.
                  </div>
                    <a 
                      href="/app/promotions?tutorial=true" 
                      className="onboarding__step-action btn gradient"
                    >Start Tutorial</a>
              </div>
            </div>
          }

          {selected === 4 && 
            <div className="onboarding__steps">
              <div className={`onboarding__step${option === 0 ? " active" : ""}${progress.giveaways ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(0)}>
                  {!progress.giveaways ? 
                    <Triangle className={`onboarding__triangle${option === 0 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">Create a demo Giveaway</div>
                </div>
                  <div className="onboarding__step-description">
                    Take the demo and learn how to create your first Giveaway.
                  </div>
                    <a 
                      href="/app/giveaways?tutorial=true" 
                      className="onboarding__step-action btn gradient"
                    >Start Tutorial</a>
              </div>
            </div>
          }

          {selected === 5 && 
            <div className="onboarding__steps">
              <div className={`onboarding__step${option === 0 ? " active" : ""}${progress.dashboard ? " onboarding__step--complete" : ""}`}>
                <div className="onboarding__step-header" onClick={() => setOption(0)}>
                  {!progress.dashboard ? 
                    <Triangle className={`onboarding__triangle${option === 0 ? ' onboarding__triangle--selected' : ''}`} /> :
                    <CircleCheck style={{marginRight: "3px"}}/>
                  }
                  <div className="onboarding__step-header-text">Explore the Dashboard</div>
                </div>
                  <div className="onboarding__step-description">
                    Learn how to get a detailed overview of how your loyalty program is performing over time.
                  </div>
                    <a 
                      href="/app/loyalty/dashboard?tutorial=true" 
                      className="onboarding__step-action btn gradient"
                    >Start Tutorial</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
}